import { Policy_KindEnum } from 'src/api/gen'

import pinAbandonedPng from './pin_abandoned.png'
import pinDwellTime from './pin_dweltime.png'
import pinGeofencePng from './pin_geofence.png'
import pinParkingPng from './pin_parking.png'
import pinSidewalkPng from './pin_sidewalk.png'
import pinSpeedPng from './pin_speed.png'

export const VIOLATION_MAP_POLICY_KINDS = [
  Policy_KindEnum.abandoned,
  Policy_KindEnum.geofence,
  Policy_KindEnum.parking,
  Policy_KindEnum.sidewalk,
  Policy_KindEnum.speed,
  Policy_KindEnum.dwell_time,
]

export const POLICY_TYPES_ICONS = {
  [Policy_KindEnum.abandoned]: pinAbandonedPng,
  [Policy_KindEnum.geofence]: pinGeofencePng,
  [Policy_KindEnum.parking]: pinParkingPng,
  [Policy_KindEnum.sidewalk]: pinSidewalkPng,
  [Policy_KindEnum.speed]: pinSpeedPng,
  [Policy_KindEnum.dwell_time]: pinDwellTime,
}
